import { accountTypes } from '../util/enum/api/accountTypes';

/** API AccountType on POST users/ssn (per SFH backend spec). */
export function mapSfhSsnAccountType(accountType) {
  if (accountType === accountTypes.Trust) return 'Trust';
  if (
    accountType === accountTypes.JointTenantsInCommon ||
    accountType === accountTypes.JointTenantsWithRightOfSurvivorship
  ) {
    return 'Joint';
  }
  return 'Individual';
}

export function buildSfhIrsDrawerCopy({
  t,
  accountType,
  primaryHolderDisplayName,
  learnMoreHref,
}) {
  const isTrust = accountType === accountTypes.Trust;
  const isIndividual = accountType === accountTypes.Individual;

  return {
    title: t('common.irsReportingRequired'),
    learnMoreHref,
    learnMoreText: t('irs.learnMore'),
    secureFootnote: t('irs.footNote'),
    inputLabel: isTrust ? t('common.tinFieldTitle') : t('common.ssnFieldTitle'),
    inputPlaceholder: isTrust
      ? t('sellWizard.sfhWizard.irsDrawer.placeholderTin')
      : t('sellWizard.sfhWizard.irsDrawer.placeholderSsn'),
    isTrust,
    isIndividual,
    primaryHolderDisplayName,
    ssnAccountType: mapSfhSsnAccountType(accountType),
  };
}
